import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";

const WdevCtaBanner: React.FC = () => {
  return (
    <section className="wdev-cta" aria-labelledby="wdev-cta-title">
      <div className="container">
        <AnimatedSection>
          <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
            <div className="wdev-cta__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <rect x="3" y="5" width="18" height="14" rx="2" stroke="#2563eb" strokeWidth="1.5" />
                <path d="M3 8l9 6 9-6" stroke="#2563eb" strokeWidth="1.5" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="wdev-cta__text">
              <h2 id="wdev-cta-title" className="wdev-cta__title">Have a Project in Mind?</h2>
              <p className="wdev-cta__subtitle">Let&apos;s build something great together.</p>
            </div>
            <Link to="/contact" className="wdev-cta__btn">
              Get In Touch
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default WdevCtaBanner;
